import { render } from "./MeetingsCalendar.vue?vue&type=template&id=b0a80980&scoped=true"
import script from "./MeetingsCalendar.vue?vue&type=script&lang=ts"
export * from "./MeetingsCalendar.vue?vue&type=script&lang=ts"

import "./MeetingsCalendar.vue?vue&type=style&index=0&id=b0a80980&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b0a80980"

export default script